/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * PreUnlink Response
 */
export interface PreUnlinkVmcOrgResponse { 
    /**
     * List of active SDDC Ids.
     */
    active_sddcs?: Array<string>;
    /**
     * Is it safe to Unlink VMC Org or not
     */
    safeToProceed?: boolean;
    /**
     * List of uncommittedPlan Ids.
     */
    uncommitted_plans?: Array<string>;
}

